import {html, PolymerElement} from '@polymer/polymer/polymer-element.js';
import '@polymer/paper-input/paper-input.js';
import '@polymer/paper-icon-button/paper-icon-button.js';
import '@polymer/iron-icon/iron-icon.js';
import '@polymer/iron-icons/iron-icons.js'
import '@polymer/iron-icons/image-icons.js';

/**
 * `cbar-search-bar`
 *
 *
 * @customElement
 * @polymer
 * @demo demo/index.html
 */
class CbarSearchBar extends PolymerElement {
  static get template() {
    return html`
      <style>
        :host {
          display: block;
        }
        paper-input{
        padding: 0 8px;
        background-color: var(--cbar-search-bar-background-color, purple);
        width: 100%;
        color:  var(--cbar-search-bar-icon-color, white);
        --secondary-text-color: var(--cbar-search-bar-text-color, white);
        --paper-input-container-input-color: var(--cbar-search-bar-text-color, white);
        --paper-input-container-underline: {
          display: none
        };
        --paper-input-container-underline-focus: {
           display: none;
        };
        --paper-input-container-underline-disabled: {
          display: none;
        };
        }
        .opener-button{
        color: grey;
        }
        #prefix-icon{
        margin-right: 8px;
        }
        #suffix-buttons-div{
        display: flex;
        flex: 1;
        }
      </style>
      <paper-input label="[[searchText]]" no-label-float on-value-changed="__fireValueChanged">
        <iron-icon icon="search" slot="prefix" id="prefix-icon"></iron-icon>
          <slot name="right-icon" slot="suffix">
             <div id="suffix-buttons-div">
                <paper-icon-button icon="close" on-tap="_clearSearch" hidden$="[[noClear]]"></paper-icon-button>
                <paper-icon-button icon="image:tune" on-tap="_fireFilterEvent" hidden$="[[noFilters]]"></paper-icon-button>
             </div>
          </slot>
      </paper-input>
    `;
  }

  static get properties() {
    return {
      /**
       * Optional Text, allows for customizable text
       */
      searchText: {
        type: String,
        value: "Search"
      },
      noFilters: {
        type: Boolean,
        value: false
      },
      noClear: {
        type: Boolean,
        value: false
      }
    };
  }

  get input() {
    if (!this._input) {
      this._input = this.root.querySelector('paper-input');
    }
    return this._input
  }

  _clearSearch() {
    this.input.value = "";
  }

  _fireFilterEvent() {
    let event = new CustomEvent('paper-search-filter', {
      bubbles: true,
      composed: true
    });

    this.dispatchEvent(event);
  }

  __fireValueChanged(e){
    this.dispatchEvent(new CustomEvent('search-value-changed',{
      bubbles: true,
      composed: true,
      detail : {
        value: e.detail.value
      }
    }));
  }
}

window.customElements.define('cbar-search-bar', CbarSearchBar);
